import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

// Tüm giderleri çek
export const fetchExpenses = createAsyncThunk(
  "expenses/fetchExpenses",
  async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });

    const res = await axios.get(`${BASE_URL}/expenses?${params.toString()}`);
    return res.data;
  }
);

// Gider kategorilerini çek
export const fetchExpenseCategories = createAsyncThunk(
  "expenses/fetchCategories",
  async () => {
    const res = await axios.get(`${BASE_URL}/expenses/categories`);
    return res.data;
  }
);

// Tek gider detayı çek
export const fetchExpenseById = createAsyncThunk(
  "expenses/fetchExpenseById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/expenses/${id}`);
    return res.data;
  }
);

// Yeni gider oluştur
export const createExpense = createAsyncThunk(
  "expenses/createExpense",
  async (expenseData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/expenses`, expenseData);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Gider oluşturulamadı"
      );
    }
  }
);

// Gider güncelle
export const updateExpense = createAsyncThunk(
  "expenses/updateExpense",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/expenses/${id}`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Gider güncellenemedi"
      );
    }
  }
);

// Gider sil
export const deleteExpense = createAsyncThunk(
  "expenses/deleteExpense",
  async (id) => {
    await axios.delete(`${BASE_URL}/expenses/${id}`);
    return id;
  }
);

const expenseSlice = createSlice({
  name: "expenses",
  initialState: {
    items: [],
    categories: [],
    selectedExpense: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedExpense: (state) => {
      state.selectedExpense = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch Categories
      .addCase(fetchExpenseCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })

      // Fetch By ID
      .addCase(fetchExpenseById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExpenseById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedExpense = action.payload;
      })
      .addCase(fetchExpenseById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.items.unshift(action.payload);
      })
      .addCase(createExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.map((expense) =>
          expense._id === action.payload._id ? action.payload : expense
        );
        if (state.selectedExpense?._id === action.payload._id) {
          state.selectedExpense = action.payload;
        }
      })
      .addCase(updateExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteExpense.fulfilled, (state, action) => {
        state.items = state.items.filter((e) => e._id !== action.payload);
        if (state.selectedExpense?._id === action.payload) {
          state.selectedExpense = null;
        }
      });
  },
});

export const { clearError, clearSelectedExpense } = expenseSlice.actions;
export default expenseSlice.reducer;
